import React from 'react';

import {
    Modal,
    Button,
    Box,
    SpaceBetween,
    Alert,
} from '@amzn/awsui-components-react-v3';

interface EditDeliveryDetailsAutoAssignConflictModalProps {
    visible: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const EditDeliveryDetailsAutoAssignConflictModal = ({
    onCancel,
    onConfirm,
    visible,
}: EditDeliveryDetailsAutoAssignConflictModalProps) => {
    return (
        <Modal
            onDismiss={() => onCancel()}
            visible={visible}
            closeAriaLabel="Close modal"
            size="medium"
            data-testid={`AutoAssignConflictModal`}
            footer={
                <Box float="right">
                    <SpaceBetween direction="horizontal" size="xs">
                        <Button
                            variant="link"
                            onClick={() => onCancel()}
                            data-testid={`AutoAssignConflictCancel`}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            data-testid={`AutoAssignConflictConfirm`}
                            onClick={() => {
                                onConfirm();
                            }}
                        >
                            Continue saving
                        </Button>
                    </SpaceBetween>
                </Box>
            }
            header={`Auto-assign instructor is enabled`}
        >
            <Alert
                onDismiss={() => {}}
                visible={true}
                dismissAriaLabel="Close alert"
                type="warning"
            >
                You have manually assigned instructors to this activity, but
                auto-assign instructor is still enabled. This may cause
                unexpected reassignments. Consider disabling auto-assign
                instructor if you want to manage assignments manually.
            </Alert>
        </Modal>
    );
};

export default EditDeliveryDetailsAutoAssignConflictModal;
